import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_service_provider_actions = _resolveComponent("service-provider-actions")!
  const _component_customer_actions = _resolveComponent("customer-actions")!
  const _component_client_actions = _resolveComponent("client-actions")!
  const _component_app_user = _resolveComponent("app-user")!

  return (_openBlock(), _createBlock(_component_app_user, null, {
    default: _withCtx(({ isServiceProvider, isCustomer, isClient }) => [
      isServiceProvider
        ? (_openBlock(), _createBlock(_component_service_provider_actions, {
            key: 0,
            account: _ctx.account
          }, null, 8, ["account"]))
        : _createCommentVNode("", true),
      isCustomer
        ? (_openBlock(), _createBlock(_component_customer_actions, {
            key: 1,
            account: _ctx.account
          }, null, 8, ["account"]))
        : _createCommentVNode("", true),
      isClient
        ? (_openBlock(), _createBlock(_component_client_actions, {
            key: 2,
            account: _ctx.account
          }, null, 8, ["account"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}